import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualConfigPageRoutingModule } from './manual-config-routing.module';

import { ManualConfigPage } from './manual-config.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualConfigPageRoutingModule
  ],
  declarations: [ManualConfigPage],
  exports: [
    ManualConfigPage,
  ],
})
export class ManualConfigPageModule {}
